function init() {
   var imgDefer = document.getElementsByTagName('img');
   for (var i=0; i<imgDefer.length; i++) {
       if(imgDefer[i].getAttribute('data-src')) {
           imgDefer[i].setAttribute('src',imgDefer[i].getAttribute('data-src'));
       }
   }

   var deferImg = document.querySelectorAll('div[data-src]');
     var style = "background-image: url({url})";
     for (var i = 0; i < deferImg.length; i++) {
       deferImg[i].setAttribute('style', style.replace("{url}", deferImg[i].getAttribute('data-src')));
   }

}
window.onload = init;